module.exports = __webpack_public_path__ + "img/10_9.cad36d85.png";